export default "__VITE_ASSET__2ccd2be1__"